import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const fadeIn = (visible: boolean, delay: string) => ({
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0)' : 'translateY(24px)',
  transition: 'all 700ms ease-out',
  transitionDelay: delay,
});

export default function CTASection() {
  const [contentRef, contentVisible] = useScrollReveal<HTMLDivElement>({ threshold: 0.2 });

  return (
    <section className="relative bg-background-50/95 py-20 md:py-28 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div ref={contentRef} className="max-w-4xl mx-auto text-center">
        <h2
          className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary-400 leading-tight mb-4"
          style={fadeIn(contentVisible, '0ms')}
        >
          Ready to Go Digital?
        </h2>
        <p
          className="text-foreground-300 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto font-body"
          style={fadeIn(contentVisible, '150ms')}
        >
          Join over 500,000 users who trust TMT for their daily financial needs. 
          Open your account in minutes and experience the future of digital payments.
        </p>
        <div style={fadeIn(contentVisible, '300ms')}>
          <Link
            to="/signup"
            className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 font-label text-sm font-semibold tracking-wider uppercase rounded-full hover:bg-primary-400 transition-colors duration-300"
          >
            Get Started Free
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Bottom Visual Banner */}
        <div className="mt-16 relative group cursor-default" style={fadeIn(contentVisible, '450ms')}>
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent z-10" />
          <div className="overflow-hidden rounded-xl border border-primary-800/20">
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20black%20and%20gold%20fintech%20app%20interface%20mockup%20banner%2C%20multiple%20premium%20digital%20cards%20and%20smartphone%20screens%20floating%20on%20dark%20background%2C%20golden%20light%20accents%2C%20elegant%20minimalist%20financial%20technology%20visualization%2C%20seamless%20horizontal%20composition&width=1400&height=400&seq=cta-banner&orientation=landscape"
              alt="TMT App Preview"
              className="w-full rounded-xl transition-transform duration-700 ease-out group-hover:scale-[1.02]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}